

















































import { Component, Mixins, Ref, Vue } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import CheckboxBase from '@/components/common/atoms/CheckboxBase.vue'
import PaginateButton from '@/components/common/atoms/PaginateButton.vue'
import LinkArea from '@/components/admin/organisms/LinkArea.vue'
import ModalMarkerAssignSetting from '@/components/admin/organisms/ModalMarkerAssignSetting.vue'
import StudyTable from '@/components/admin/organisms/StudyListForAssignTable.vue'
import StudyListForAssignApis, {
  StudyData,
  StudySearchQuery,
  SubjectsType,
  AssignStatusType,
  ModalMarkerType,
} from '@/mixins/requests/admin/StudyListForAssignApis.vue'
import CookieMethods from '@/mixins/CookieMethods.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    CheckboxBase,
    PaginateButton,
    StudyTable,
    LinkArea,
    ModalMarkerAssignSetting,
  },
})
export default class StudyList extends Mixins(StudyListForAssignApis, CookieMethods) {
  private gradeId: number | null = null
  private subjectId: number | null = null
  private studyName = ''
  private sProblemSortNum: number | null = null
  private questionSortNum: number | null = null
  private answerFormat = ''
  private assignStatus: string[] = []
  private currentQuery: StudySearchQuery = {}

  private gradeOptions: SelectOption[] = []
  private subjectOptions: SubjectsType[] = []
  private answerFormatOptions: SelectOption[] = []
  private assignStatusCheckboxes: AssignStatusType[] = []

  private studyList: StudyData[] = []
  private studyListPaginate: StudyData[] = []
  private pageCount = 0
  private viewPage = 1

  /** ref: 氏名変更モーダル */
  @Ref() modalMarkerAssignSetting!: ModalMarkerAssignSetting
  /** ref: 振分一覧ページネート */
  @Ref() studyListPaginateButton!: PaginateButton

  private modalMarkerList: ModalMarkerType[] = []

  private async mounted() {
    // TODO: 検索条件の復元
    Vue.prototype.$loading.start()
    try {
      this.gradeOptions = await this.loadGrades()
      this.subjectOptions = await this.loadSubjects()
      this.answerFormatOptions = await this.getAnswerFormat()
      this.assignStatusCheckboxes = await this.getAssignStatus()
      await this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async onClickSearch() {
    Vue.prototype.$loading.start()
    try {
      await this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async search(isPageReset = true) {
    this.currentQuery = {}
    if (this.gradeId) this.currentQuery.gradeId = this.gradeId
    if (this.subjectId) this.currentQuery.subjectId = this.subjectId
    if (this.studyName) this.currentQuery.studyName = this.studyName
    if (this.sProblemSortNum) this.currentQuery.sProblemSortNum = this.sProblemSortNum
    if (this.questionSortNum) this.currentQuery.questionSortNum = this.questionSortNum
    if (this.answerFormat) this.currentQuery.answerFormat = this.answerFormat
    if (this.assignStatus) this.currentQuery.assignStatus = this.assignStatus

    await this.searchStudies(
      this.currentQuery,
      async (studyList: StudyData[]) => {
        this.studyList = studyList
        this.studyListPaginateButton.init(this.studyList, isPageReset)
      },
      (err: any) => {
        Vue.prototype.$logger.log(err)
        alert('エラーが発生しました')
      }
    )
  }

  /**
   * ページネーション一覧表示更新
   */
  private onClickPaginate(paginateList: StudyData[]) {
    // コンポーネントで生成されたリストを表示
    this.studyListPaginate = paginateList
  }

  /**
   * 状態検索チェックボックス
   */
  private onCheckAssignStatus(statusCode: string, checked: boolean) {
    // 状態コードを配列に保持
    if (checked) this.assignStatus.push(statusCode)
    else {
      this.assignStatus = this.assignStatus.filter((assignStatusName) => assignStatusName != statusCode)
    }
  }

  /**
   * 公開ボタン処理
   */
  private async onClickPublishButton(studyContentId: number, questionId: number) {
    await this.scoringIsPublicUpdateApi(
      studyContentId,
      questionId,
      () => {
        this.studyList
          .filter((study: StudyData) => study.studyContentId === studyContentId && study.questionId === questionId)
          .map((study: StudyData) => {
            // TODO: 更新成功後、APIは対象設問情報を返し、その値を表示するようにする
            study.isPublic = true
            study.assignStatus = 'Completion'
          })
      },
      (err: any) => {
        Vue.prototype.$logger.log(err)
        alert('エラーが発生しました')
      }
    )
  }

  /**
   * 振り分けモーダル表示
   */
  private async onClickAssignButton(studyContentId: number, questionId: number) {
    const targetQuestion: StudyData | undefined = this.studyList.find(
      (studyList: StudyData) => studyList.studyContentId === studyContentId && studyList.questionId === questionId
    )
    if (!targetQuestion) return

    this.modalMarkerAssignSetting.show()

    await this.modalMarkerAssignSetting.init(targetQuestion)
  }

  /**
   * 振り分けモーダル：リセット、保存実行時処理
   */
  private async saveMarkerAssignSetting() {
    Vue.prototype.$loading.start()
    try {
      await this.search(false)
    } finally {
      Vue.prototype.$loading.complete()
    }
  }
}
